var render = function render(){var _vm=this,_c=_vm._self._c;return _c('placeholder-panel',[_c('h1',{staticClass:"display-2 text-center"},[_vm._v("👪")]),_c('h5',{staticClass:"text-center mb-0"},[_vm._v(" Select a "),_c('strong',[_vm._v("chat group")]),_vm._v(" for details ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }